module.exports = __webpack_public_path__ + "static/media/no_pages.91e1b4c0.svg";